import { TProduct } from '@/shared/types/product-types'

export const filterAvailableProducts = (product: TProduct): boolean =>
	product.ORDER_TYPE !== 'HIDE_BUY' && product.ORDER_TYPE !== 'ARCHIVE' && product.BUTTON_NAME !== 'Нет в наличии'
